// Componente de página para Listagem Forum Moderação
// Este elemento é referenciado na configuração de rotas em src/routes.js
import ListaForumModeracao from "../../componentes/ListaForumModeracao";



const ListagemForumModeracao = () => {
    return (
        <div>
            <div className="container-fluid mt-3">
                <ListaForumModeracao />
            </div>
        </div>
    );
};

export default ListagemForumModeracao;